import React from 'react';
import Slider from 'material-ui/Slider';

const DurationSlider = ({ duration, handleDurationFilter }) => (
  <div className="filter-container">
    <h4 className="filter-title">Duration</h4>
    <div className="filter-content">
      <Slider
        className="slider"
        disableFocusRipple
        max={12}
        step={4}
        min={4}
        sliderStyle={{ marginBottom: '1em' }}
        value={duration}
        onChange={(e, v) => {
          handleDurationFilter(v);
        }}
      />
      <div className="slider-label">
        <span style={duration === 4 ? { fontWeight: '600' } : {}}>4h</span>
        <span style={duration === 8 ? { fontWeight: '600' } : {}}>8h</span>
        <span style={duration === 12 ? { fontWeight: '600' } : {}}>12h</span>
      </div>
    </div>
  </div>
);

export default DurationSlider;



// WEBPACK FOOTER //
// ./src/components/Book/FilterSidebar/DurationSlider.js